import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.Model.extend({
  url: COACHHUB_USER_API_URL,
  list_image: function () {
    return this.user_image('list');
  },
  full_image: function () {
    return this.user_image('full');
  },
  user_image: function (image_type) {
    var default_img = STATIC_URL + 'img/mh-' + GLOBALS.BRANDING + '.png';
    if (this.get('user').images) {
      return this.get('user').images[image_type];
    }
    return default_img;

  },
  // Return the user's escaped display name
  display_name: function () {
    return _.escape(this.get('user').display_name);
  },
  can_contact_coaches: function () {
    return GLOBALS.SITE_CODE != 'mos' || this.get('is_authorized');
  }
});



// WEBPACK FOOTER //
// ./static/js/models/coachhub_user.js